import React from 'react';
import styles from '../styles/ContactUs.module.css';
import Navbar from '../components/Navbar';
import ContactForm from '../components/ContactForm';
import { Link } from 'react-router-dom';

const ContactUs: React.FC = () => {
  return (
    <div>
        <Navbar />
        <p className={styles.title}>Contact Us</p>
        <div className={styles.container}>
          <div>
            <p className={styles.text}>Split Heritage</p>
            <Link className={styles.text} to='https://www.google.com/maps/place/Ul.+Theodorea+Roosevelta+15,+21000,+Split/@43.5033524,16.4485404,17z/data=!3m1!4b1!4m6!3m5!1s0x133560a819979bf9:0xce0f230948b3b9c5!8m2!3d43.5033485!4d16.4511153!16s%2Fg%2F11c27g553t?entry=ttu'>
                    Rooseveltova ulica 15, Split</Link>
            <div className={styles.linkContainer}>
              <a href='tel:+38521571830' className={styles.text}>+385 21 571830</a>
              <a href='mailto:presidentsplitheritage@gmail.com' className={styles.text}>presidentsplitheritage@gmail.com</a>
            </div>
          </div>
          <ContactForm />
        </div>
    </div>
  );
};

export default ContactUs;